import styled from "@emotion/styled";
export const StyledDesktopTemplatePageContent = styled.div`
  width: 100%;

  .template-top-section-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .template-field-wrapper {
    padding-bottom: 8px;
  }

  .template-description-wrapper {
    margin-top: 42px;
    max-width: 720px;

    .template-description {
      font-size: 0.875rem;
      line-height: 150%;
    }
  }

  .template-page-tabs-wrapper {
    margin-top: 42px;
    margin-bottom: 64px;
  }
`;
